import React from "react";
import { Container, Title } from "../general/index";
import { FEATURES } from "../../data/features";
import FeaturesList from "./FeaturesList";

const Features = () => {
  return (
    <Container className="py-10" id="features">
      <Title margin="8" className="text-center" fontSize="3xl">
        Discover Our Features
      </Title>
      <FeaturesList features={FEATURES} />
    </Container>
  );
};

export default Features;
